import { render } from "./BulkUploadProducts.vue?vue&type=template&id=78dd12fe&scoped=true"
import script from "./BulkUploadProducts.vue?vue&type=script&lang=js"
export * from "./BulkUploadProducts.vue?vue&type=script&lang=js"

import "./BulkUploadProducts.vue?vue&type=style&index=0&id=78dd12fe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78dd12fe"]])

export default __exports__